import { LumberSet } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { getLoggedInUserOrganization } from '@paragon/login-tools';

import { receiveMaterialListEditResponse } from './receiveMaterialListEditResponse';
import { AsyncThunkActionReturn, ThunkActionVoid } from './thunkActionTypes';

export const createLumberSet =
  (lumberListGuid: string): AsyncThunkActionReturn<string> =>
  async (dispatch) => {
    const guid = crypto.randomUUID();
    const lumberSet: LumberSet = {
      guid,
      species: [],
      comboSpecies: [],
      grades: [],
      comboGrades: [],
      treatmentTypes: ['Untreated'],
      actualDimensions1: [],
      actualDimensions2: [],
      stockLengths: [],
    };

    await dispatch(upsertLumberSet(lumberListGuid, lumberSet));
    return guid;
  };

export const upsertLumberSet =
  (lumberListGuid: string, updatedLumberSet: LumberSet): ThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const organization = getLoggedInUserOrganization(state);

    if (organization == null) throw new Error('Unauthenticated user attempted to edit lumber set.');

    const result = await designService.materialLists.upsertLumberSet(
      organization,
      lumberListGuid,
      updatedLumberSet.guid,
      updatedLumberSet,
    );
    dispatch(receiveMaterialListEditResponse(result));
  };

export const deleteLumberSet =
  (lumberListGuid: string, lumberSetGuid: string): ThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const organization = getLoggedInUserOrganization(state);

    if (organization == null) throw new Error('Unauthenticated user attempted to delete lumber set.');

    const result = await designService.materialLists.deleteLumberSet(organization, lumberListGuid, lumberSetGuid);
    dispatch(receiveMaterialListEditResponse(result));
  };
